// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as HtmlWithUnsafeJavascriptExecution$Showside from "../utils/HtmlWithUnsafeJavascriptExecution.bs.js";
function InjectJS(Props) {
  var js = Props.js;
  return React.createElement(HtmlWithUnsafeJavascriptExecution$Showside.make, {
    children: "<script>\n		try {\n			" + js + "\n		} catch (e) {\n			console.error(\"Error executing JS:\", e)\n		}\n	</script>"
  });
}
InjectJS.displayName = "InjectJS";
var make = InjectJS;
export { make };
/* react Not a pure module */